<div class="page-content bg-white">
  <!-- inner page banner -->

  <!-- inner page banner END -->
  <!-- Breadcrumb row -->
  <div class="breadcrumb-row">
    <div class="container">
      <ul class="list-inline">
        <li><a href="#">Inicio</a></li>
        <li>Noticia</li>
      </ul>
    </div>
  </div>
  <!-- Breadcrumb row END -->
  <!-- contact area -->
  <div class="content-area">
    <!-- Career -->
    <div class="container">
      <div class="row">
        <!-- Left part start -->
        <div class="col-md-9 m-b30">
          <img src="{{domain}}{{noticia[0].imagen}}" alt="">
          <h1 class="m-b20 m-t0">{{ noticia[0].titulo }} </h1>
          <a href="http://mpd.planificacion.gob.bo/{{url}}">
            <img src="/assets/pdf.png" alt="">
          </a>
          <span class="twitter"><a
              href="https://twitter.com/intent/tweet?url=http://www.planificacion.gob.bo/noticia/{{noticia[0].id}}&related=PLANIFICACION&text={{noticia[0].titulo}}&via=planificacion.gob.bo">
              <img src="/assets/twitter.png" alt="">
            </a></span>
          <a class="fb-share-button"
            href="https://www.facebook.com/sharer/sharer.php?kid_directed_site=0&sdk=joey&u={{domain}}index.php/xnoticias/noticia/{{noticia[0].id}}&display=popup&ref=plugin&src=share_button"
            data-layout="icon">
            <img src="/assets/facebook.png" alt="">
          </a>
          <br>

          <div class="dez-separator bg-primary"></div>

          <p style="text-align: justify;" [innerHTML]="noticia[0].texto"></p>
        </div>
        <!-- Left part start END -->
        <!-- Right part start -->
        <div class="col-md-3">
          <div class="widget bg-white recent-posts-entry">
            <h4 class="widget-title">Documentos importantes</h4>
            <div class="widget-post-bx">
              <ng-container *ngFor="let item of documentos">
                <div class="widget-post clearfix">
                  <div class="dez-post-media"> <img src="{{domain}}{{item.imagen}}" alt="" width="200" height="143">
                  </div>
                  <div class="dez-post-info">
                    <div class="dez-post-header">
                      <h6 class="post-title">
                        <div *ngIf="item.url>0;then uno else dos"></div>
                        <ng-template #uno>
                          <a routerLink="/content/{{item.url}}">{{item.titulo}}</a>
                        </ng-template>
                        <ng-template #dos>
                          <a target="_blank" href="{{domain}}/{{item.url}}">{{item.titulo}}</a>
                        </ng-template>
                      </h6>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <!-- Right part start END -->
      </div>
    </div>
    <!-- Career END -->
  </div>
  <!-- contact area END -->
</div>


// WEBPACK FOOTER //
// ./src/app/pages/noticia/noticia.component.html